export const set_page_title = (title) => dispatch => {
    dispatch({
        type: "SET_PAGE_TITLE",
        title: title
    });
}
export const open_navigation = () => dispatch => {
    dispatch({
        type: "OPEN_NAVIGATION"
    });
}
export const close_navigation = () => dispatch => {
    dispatch({
        type: "CLOSE_NAVIGATION"
    });
}